/* eslint-disable no-console */
import React, { FC, useEffect, useMemo } from 'react'

import shortenAddress from '@ambire-common/utils/shortenAddress'
import { Props as TextProps } from '@common/components/Text'
import useContractNamesContext from '@common/hooks/useContractNamesContext/useContractNamesContext'
import useReverseLookup from '@common/hooks/useReverseLookup'

import BaseAddress from '../BaseAddress'

interface Props extends TextProps {
  address: string
  chainId: bigint
}

const BenzinAddressName: FC<Props> = ({ address, chainId, ...rest }) => {
  // Intentionally ignore reverseLookup's `isLoading`: on chains without an ETH
  // reverse-resolution provider (e.g. Unichain) it never flips to false, so
  // gating the render on it left a permanent spinner. Show a stable shortened
  // address immediately and upgrade to the ens/contract name once it resolves.
  const { ens } = useReverseLookup({ address })
  const { contractNamesCtrl, state } = useContractNamesContext()

  useEffect(() => {
    if (!contractNamesCtrl.contractNames?.[address]) contractNamesCtrl.getName(address, chainId)
  }, [address, chainId, contractNamesCtrl])

  const foundContractName = useMemo(() => {
    const name = state.contractNames?.[address]?.name
    if (!name) return
    return name
  }, [state, address])

  return (
    <BaseAddress address={address} {...rest}>
      {/* Shorten the raw-address fallback (0x123456…abcdef) so a full 42-char
          address can't overflow and break the row layout on narrow/mobile
          screens; resolved names render in full. */}
      {ens || foundContractName || shortenAddress(address, 18, 6)}
    </BaseAddress>
  )
}

export default BenzinAddressName
